import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-black">
      {/* Back Button */}
      <div className="container mx-auto px-6 pt-8">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 transition-colors"
        >
          <ArrowLeft size={20} />
          <span>Back to Home</span>
        </Link>
      </div>

      <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '60px 20px', background: '#000', color: '#fff' }}>
        
        <h1 style={{ fontSize: '48px', color: '#00d4ff', textAlign: 'center', marginBottom: '30px', textTransform: 'uppercase', letterSpacing: '3px' }}>
          Privacy Policy
        </h1>
        
        <p style={{ fontSize: '14px', color: '#888', textAlign: 'center', marginBottom: '50px' }}>
          Last Updated: April 10, 2026
        </p>
        
        <div style={{ fontSize: '16px', color: '#ccc', lineHeight: '1.9' }}>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>1. Introduction</h2>
          <p>EFAM ("we," "us," "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your personal information in accordance with the Australian Privacy Act 1988 (Cth) and the Australian Privacy Principles (APPs).</p>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>2. Information We Collect</h2>
          
          <h3 style={{ color: '#fff', fontSize: '20px', margin: '30px 0 15px' }}>2.1 Personal Information</h3>
          <p>We may collect the following types of personal information:</p>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li><strong>Contact Information:</strong> Name, email address, phone number, shipping address, billing address</li>
            <li><strong>Payment Information:</strong> Credit card details (processed securely through Stripe - we do not store complete card details)</li>
            <li><strong>Order Information:</strong> Purchase history, product preferences, shipping preferences</li>
            <li><strong>Communication Records:</strong> Email correspondence, text messages, customer service interactions</li>
            <li><strong>Technical Information:</strong> IP address, browser type, device information, website usage data</li>
          </ul>
          
          <h3 style={{ color: '#fff', fontSize: '20px', margin: '30px 0 15px' }}>2.2 How We Collect Information</h3>
          <p>We collect information when you:</p>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li>Create an account or place an order</li>
            <li>Contact us via email, phone, or text</li>
            <li>Subscribe to our newsletter or marketing communications</li>
            <li>Browse our website (via cookies and analytics)</li>
            <li>Participate in surveys or promotions</li>
          </ul>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>3. How We Use Your Information</h2>
          <p>We use your personal information for the following purposes:</p>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li><strong>Order Processing:</strong> To process, fulfill, and ship your orders</li>
            <li><strong>Customer Service:</strong> To respond to inquiries, provide support, and resolve issues</li>
            <li><strong>Payment Processing:</strong> To process payments securely via Stripe</li>
            <li><strong>Communication:</strong> To send order confirmations, shipping updates, and important account information</li>
            <li><strong>Marketing:</strong> To send promotional emails, product updates, and special offers (with your consent)</li>
            <li><strong>Legal Compliance:</strong> To comply with Australian tax, GST, and business regulations</li>
            <li><strong>Business Improvement:</strong> To analyze website usage, improve our products and services</li>
          </ul>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>4. Disclosure of Your Information</h2>
          <p>We may share your personal information with:</p>
          
          <h3 style={{ color: '#fff', fontSize: '20px', margin: '30px 0 15px' }}>4.1 Service Providers</h3>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li><strong>Payment Processors:</strong> Stripe (for secure payment processing)</li>
            <li><strong>Shipping Carriers:</strong> Freight companies and logistics providers (to deliver your orders)</li>
            <li><strong>Email Services:</strong> Marketing and communication platforms (to send emails)</li>
            <li><strong>Web Hosting:</strong> Website hosting and infrastructure providers</li>
          </ul>
          
          <h3 style={{ color: '#fff', fontSize: '20px', margin: '30px 0 15px' }}>4.2 Legal Requirements</h3>
          <p>We may disclose your information if required by law, court order, or government authority, or to protect our legal rights and safety.</p>
          
          <h3 style={{ color: '#fff', fontSize: '20px', margin: '30px 0 15px' }}>4.3 Business Transfers</h3>
          <p>If EFAM is acquired or merged with another company, your information may be transferred to the new owner.</p>
          
          <p><strong>We do NOT:</strong></p>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li>Sell your personal information to third parties</li>
            <li>Share your information for third-party marketing without your consent</li>
            <li>Use your information for purposes beyond those described in this policy</li>
          </ul>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>5. Data Security</h2>
          <p>We implement industry-standard security measures to protect your personal information, including:</p>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li><strong>SSL Encryption:</strong> Secure data transmission on our website</li>
            <li><strong>Secure Payment Processing:</strong> PCI-compliant payment processing via Stripe</li>
            <li><strong>Access Controls:</strong> Limited access to personal information by authorized personnel only</li>
            <li><strong>Regular Security Audits:</strong> Ongoing monitoring and security updates</li>
          </ul>
          <p>However, no method of electronic storage or transmission is 100% secure. We cannot guarantee absolute security of your data.</p>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>6. Your Privacy Rights (Australian Privacy Principles)</h2>
          <p>Under Australian Privacy Law, you have the right to:</p>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li><strong>Access:</strong> Request a copy of the personal information we hold about you</li>
            <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information</li>
            <li><strong>Deletion:</strong> Request deletion of your personal information (subject to legal retention requirements)</li>
            <li><strong>Opt-Out:</strong> Unsubscribe from marketing communications at any time</li>
            <li><strong>Complaint:</strong> Lodge a complaint about our privacy practices</li>
          </ul>
          <p>To exercise any of these rights, contact us via our Contact page.</p>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>7. Cookies and Tracking Technologies</h2>
          <p>We use cookies and similar technologies to:</p>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li>Remember your preferences and settings</li>
            <li>Analyze website traffic and user behavior</li>
            <li>Improve website functionality and user experience</li>
            <li>Track marketing campaign effectiveness</li>
          </ul>
          <p>You can control cookies through your browser settings. Disabling cookies may affect website functionality.</p>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>8. Third-Party Links</h2>
          <p>Our website may contain links to third-party websites (e.g., Stripe, social media). We are not responsible for the privacy practices of these external sites. Please review their privacy policies before providing personal information.</p>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>9. Data Retention</h2>
          <p>We retain your personal information for as long as necessary to:</p>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li>Fulfill the purposes described in this policy</li>
            <li>Comply with legal and tax obligations (e.g., GST records for 7 years)</li>
            <li>Resolve disputes and enforce agreements</li>
          </ul>
          <p>After this period, we will securely delete or anonymize your information.</p>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>10. International Data Transfers</h2>
          <p>Your information may be transferred to and stored on servers outside Australia (e.g., cloud hosting providers). We ensure that any international transfers comply with Australian privacy laws and that your data receives adequate protection.</p>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>11. Children's Privacy</h2>
          <p>Our website and products are not intended for individuals under 18 years of age. We do not knowingly collect personal information from children. If we become aware that we have collected information from a child, we will delete it promptly.</p>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>12. Changes to This Privacy Policy</h2>
          <p>We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated "Last Updated" date. Your continued use of our website after changes constitutes acceptance of the updated policy.</p>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>13. Contact Us</h2>
          <p>If you have questions about this Privacy Policy or wish to exercise your privacy rights, contact us at:</p>
          <p style={{ marginTop: '10px' }}><strong>Business:</strong> EASY FITNESS & MASSAGE<br />
          <strong>ABN:</strong> 88 644 774 778<br />
          <strong>Email:</strong> efamfitness@gmail.com<br />
          <strong>Phone:</strong> 0490 792 050 (9am-5pm)<br />
          <strong>Location:</strong> Footscray, Victoria 3011, Australia</p>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>14. Complaints</h2>
          <p>If you have a privacy complaint, please contact us first. We will investigate and respond within a reasonable timeframe. If you are not satisfied with our response, you may lodge a complaint with the Office of the Australian Information Commissioner (OAIC):</p>
          <p><strong>Website:</strong> www.oaic.gov.au<br />
          <strong>Phone:</strong> 1300 363 992</p>
          
        </div>
        
      </div>
    </div>
  );
};

export default PrivacyPage;
